module.exports = __webpack_public_path__ + "img/3.6865c81f.png";